import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';

class App extends Component {
  render() {
    return (
      <div>
        <h1>Demo PAGE</h1>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/demo/App.js